<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    data() {
        return {
            title: "Listado de Pago Laborantes",
            items: [
                {
                text: "Laborantes",
                href: "/web/configuracion/laborantes"
                },
                {
                text: "Listado de Pago",
                active: true
                }
            ],
            pagos_laborantes:[],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            desde:'',
            hasta:'',
            us:{ nombre_laborante: '' },
            tipos:[],
            subtipos:[],
        };
    },
    computed:{
        filteredData() {
            let datos = [...this.pagos_laborantes];

            // Aplicar filtro si existe
            if (this.filtro) {
                datos = datos.filter((item) => {
                    return item.nombre_laborante.toLowerCase().includes(this.filtro.toLowerCase());
                });
            }

            // Ordenar por total_liquido de mayor a menor
            return datos.sort((a, b) => {
                const montoA = parseInt(a.total_liquido) || 0;
                const montoB = parseInt(b.total_liquido) || 0;
                return montoB - montoA; // Mayor a menor
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalRows() {
            return this.filteredData.length;
        },
    },
    watch: {
        filtro() {
            this.currentPage = 1;
        },
        perPage() {
            this.currentPage = 1;
        },
        pagos_laborantes() {
            this.currentPage = 1;
        },
    },
    methods:{
        obtenerRangoFechas() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();

            let fechaInicio, fechaFin;

            if (diaHoy <= 25) {
                // Si hoy es menor o igual a 25, el rango es del 26 del mes anterior al 25 de este mes
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                // Si hoy es mayor a 25, el rango es del 26 de este mes al 25 del mes siguiente
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }
            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            //return { fechaInicio, fechaFin };
        },
        mostrarmes(){
            axios.get('/api/apagar/'+this.desde+'/'+this.hasta).then(response => {
                if (this.user.rol=='SuperAdmin' || this.user.rol=='Admin' || this.user.rol=='Supervisor' || this.user.rol=='Gastos') {
                    this.pagos_laborantes= response.data.pagos_laborantes;
                }else if(this.user.rol=='Coordinador'){
                    this.pagos_laborantes = response.data.pagos_laborantes
                    // 1. Filtra solo laborantes donde el coordinador actual está incluido
                    .filter(laborante => laborante.coordinadores.includes(this.user.id))
                    // 2. Filtra los pagos de cada laborante para que solo se muestren los del coordinador actual
                    .map(laborante => {
                        return {
                            ...laborante,
                            pagos: laborante.pagos.filter(pago => pago.user_id == this.user.id)
                        };
                    });
                }
            });
        },
        format_Valor_variable(val){
            const monto = Number(val);
            return (Number.isFinite(monto) ? Math.round(monto) : 0).toLocaleString("es-CL", { style: "currency", currency: "CLP" });
        },
        ver_detalle(user){
            this.us=user;
            this.us.pagos.forEach(element => {
                element.tipo_nombre = this.tipos.find(t => t.codigo == element.tipo);
                element.subtipo_nombre = this.subtipos.find(t => t.codigo == element.subtipo);
            });
            this.$refs['modal-detalle'].show()
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
    },
    mounted(){
        this.obtenerRangoFechas();
        this.mostrarmes();
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Desde :" label-for="text" >
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Hasta :" label-for="text" >
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-button variant="primary" block class="mb-4" @click="mostrarmes">Ver</b-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-money font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Listado de Pago Laborantes</h5>
                            <small class="text-white" style="opacity:.8;">Revisa el listado de pagos de laborantes</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th >Nº</th>
                                        <th >Nombre</th>
                                        <th >Rut</th>
                                        <th >Total a Pagar</th>
                                        <th >Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index" :class="item.total_liquido>=250000 ?'bg-danger text-white':''">
                                        <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                        <td>{{ item.nombre_laborante }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ format_Valor_variable(item.total_liquido) }}</td>
                                        <td>
                                            <b-button variant="primary" size="sm" @click="ver_detalle(item)">Ver</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <b-modal ref="modal-detalle" size="xl" hide-footer :title="'Pagos ' + (us.nombre_laborante || '')">
                            <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th >Nº</th>
                                        <th >Evento(s)</th>
                                        <th >Fecha</th>
                                        <th >Tipo</th>
                                        <th >Subtipo</th>
                                        <th >Tipo apoyo</th>
                                        <th >Horas</th>
                                        <th >Coordinador</th>
                                        <th >Comentario</th>
                                        <th >Monto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item2, index2) in us.pagos" :key="index2">
                                        <td>{{ index2 + 1 }}</td>
                                        <td>{{ item2.cod_evento }}</td>
                                        <td>{{ formatFecha(item2.fecha) }}</td>
                                        <td>{{ item2.tipo_nombre ? item2.tipo_nombre.nombre : item2.tipo }}</td>
                                        <td>{{ item2.subtipo_nombre ? item2.subtipo_nombre.nombre : item2.subtipo }}</td>
                                        <td>{{ item2.tipo_laborante }}</td>
                                        <td>{{ item2.total_horas }}</td>
                                        <td>{{ item2.user_id }}</td>
                                        <td>{{ item2.comentario || '-' }}</td>
                                        <td>{{ format_Valor_variable(item2.valor_liquido) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        </b-modal>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
